import React from "react";
import portifolio1 from'./static/portifolio/portfolio-1.png';
import portifolio1_1 from './static/portifolio/portifolio1/portfolio-details-1.png'
import portifolio1_2 from './static/portifolio/portifolio1/portfolio-details-2.png'
import portifolio1_3 from './static/portifolio/portifolio1/portfolio-details-3.png'

import portifolio2_1 from './static/portifolio/portifolio2/portfolio-details-1.png'
import portifolio2_2 from './static/portifolio/portifolio2/portfolio-details-2.png'
import portifolio2_3 from './static/portifolio/portifolio2/portfolio-details-3.png'

import portifolio3_1 from './static/portifolio/portifolio3/portfolio-details-1.png'
import portifolio3_2 from './static/portifolio/portifolio3/portfolio-details-2.png'
import portifolio3_3 from './static/portifolio/portifolio3/portfolio-details-3.png'
import portifolio3_4 from './static/portifolio/portifolio3/portfolio-details-4.png'
import portifolio3_5 from './static/portifolio/portifolio3/portfolio-details-5.png'
import portifolio3_6 from './static/portifolio/portifolio3/portfolio-details-6.png'
import portifolio3_7 from './static/portifolio/portifolio3/portfolio-details-7.png'
import portifolio3_8 from './static/portifolio/portifolio3/portfolio-details-8.png'
import portifolio3_9 from './static/portifolio/portifolio3/portfolio-details-9.png'

import portifolio4_1 from './static/portifolio/portifolio4/portfolio-details-1.png'
import portifolio4_2 from './static/portifolio/portifolio4/portfolio-details-2.png'
import portifolio4_3 from './static/portifolio/portifolio4/portfolio-details-3.png'
import portifolio4_4 from './static/portifolio/portifolio4/portfolio-details-4.png'
import portifolio4_5 from './static/portifolio/portifolio4/portfolio-details-5.png'

import portifolio5_1 from './static/portifolio/portifolio5/portfolio-details-1.png'
import portifolio5_2 from './static/portifolio/portifolio5/portfolio-details-2.png'
import portifolio5_3 from './static/portifolio/portifolio5/portfolio-details-3.png'
import portifolio5_4 from './static/portifolio/portifolio5/portfolio-details-4.png'
import portifolio5_5 from './static/portifolio/portifolio5/portfolio-details-5.png'
import portifolio5_6 from './static/portifolio/portifolio5/portfolio-details-6.png'
import portifolio5_7 from './static/portifolio/portifolio5/portfolio-details-7.png'
import portifolio5_8 from './static/portifolio/portifolio5/portfolio-details-8.png'
import portifolio5_9 from './static/portifolio/portifolio5/portfolio-details-9.png'
import portifolio5_10 from './static/portifolio/portifolio5/portfolio-details-10.png'
import portifolio5_11 from './static/portifolio/portifolio5/portfolio-details-11.png'

import portifolio6_1 from './static/portifolio/portfolio-7.png'
import portifolio6_2 from './static/portifolio/portifolio6/portfolio-details-1.png'
import portifolio6_3 from './static/portifolio/portifolio6/portfolio-details-2.png'
import portifolio6_4 from './static/portifolio/portifolio6/portfolio-details-3.png'
import portifolio6_5 from './static/portifolio/portifolio6/portfolio-details-4.png'
import portifolio6_6 from './static/portifolio/portifolio6/portfolio-details-5.png'
import portifolio6_7 from './static/portifolio/portifolio6/portfolio-details-6.png'
import portifolio6_8 from './static/portifolio/portifolio6/portfolio-details-7.png'
import portifolio6_9 from './static/portifolio/portifolio6/portfolio-details-8.png'
import portifolio6_10 from './static/portifolio/portifolio6/portfolio-details-9.png'
import portifolio6_11 from './static/portifolio/portifolio6/portfolio-details-10.png'



import portifolio7_1 from './static/portifolio/portifolio7/portfolio-details-1.png'
import portifolio7_2 from './static/portifolio/portifolio7/portfolio-details-2.png'
import portifolio7_3 from './static/portifolio/portifolio7/portfolio-details-3.png'
import portifolio7_4 from './static/portifolio/portifolio7/portfolio-details-4.png'
import portifolio7_5 from './static/portifolio/portifolio7/portfolio-details-5.png'



import appVendasfile from './files/app-vendas.zip'
import flappyBirdfile from './files/flappybird.zip'
import pull_itTrainfile from './files/Pull-it Train.zip'
import fooFighterfile from './files/foo fighter.zip'
import ImageCarousel from "./carrosel";


const image1 = [
  portifolio1_1,
  portifolio1_2,
  portifolio1_3
]

const image2 = [
  portifolio2_1,
  portifolio2_2,
  portifolio2_3
]

const image3 = [
  portifolio3_1,
  portifolio3_2,
  portifolio3_3,
  portifolio3_4,
  portifolio3_5,
  portifolio3_6,
  portifolio3_7,
  portifolio3_8,
  portifolio3_9
]

const image4 = [
  portifolio4_1,
  portifolio4_2,
  portifolio4_3,
  portifolio4_4,
  portifolio4_5,
]

const image5 = [
  portifolio5_1,
  portifolio5_2,
  portifolio5_3,
  portifolio5_4,
  portifolio5_5,
  portifolio5_6,
  portifolio5_7,
  portifolio5_8,
  portifolio5_9,
  portifolio5_10,
  portifolio5_11,
]

const image6 = [
  portifolio6_1,
  portifolio6_2,
  portifolio6_3,
  portifolio6_4,
  portifolio6_5,
  portifolio6_6,
  portifolio6_7,
  portifolio6_8,
  portifolio6_9,
  portifolio6_10,
  portifolio6_11
]

const image7 = [
  portifolio7_1,
  portifolio7_2,
  portifolio7_3,
  portifolio7_4,
  portifolio7_5,
]

const Portfolio_details = ({index, isclicked, onButtonClicked, isEnglish}) => {
  if (!isEnglish){
    if (isclicked){
      if (index === 1){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image1} />
            </div>
            <div className="side2">
              <h1>Controle de Vendas</h1>
              <div className="info">
                <div className="text">
                <h1>Categoria: </h1>
                  <p> Desenvolvimento de App</p>
                </div>
                <div className="text">
                <h1>Intuito: </h1>
                  <p className="get_smaller"> Um aplicativo criado para conectar vendedores e controlar suas vendas.</p>
                </div>
                <div className="button_place">
                  <a href={appVendasfile} download='App-Vendas' target="_blank"><button>Download</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 2){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image2} />
            </div>
            <div className="side2">
              <h1>Flappy Bird</h1>
              <div className="info">
                <div className="text">
                <h1>Categoria: </h1>
                  <p> Desenvolvimento de Game</p>
                </div>
                <div className="text">
                <h1>Intuito: </h1>
                  <p className="get_smaller">  Um game baseado no jogo Flappy bird</p>
                </div>
                <div className="button_place">
                  <a href={flappyBirdfile} download='FlappyBird' target="_blank"><button>Download</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 3){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image3} />
            </div>
            <div className="side2">
              <h1>Pull-it Train</h1>
              <div className="info">
                <div className="text">
                <h1>Categoria: </h1>
                  <p> Desenvolvimento de Programa</p>
                </div>
                <div className="text">
                <h1>Intuito: </h1>
                  <p className="get_smaller"> Um programa feito para ajudar pessoas que praticam atividades físicas manter sua rotina de treinos, suplementos, remédios e trabalho</p>
                </div>
                <div className="button_place">
                  <a href={pull_itTrainfile} download='Pull-it Train' target="_blank"><button>Download</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 4){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image4} />
            </div>
            <div className="side2">
              <h1>Management Web</h1>
              <div className="info">
                <div className="text">
                <h1>Categoria: </h1>
                  <p> Construção de Site</p>
                </div>
                <div className="text">
                <h1>Intuito: </h1>
                  <p className="get_smaller"> Um site feito para auxiliar na gestão de empresas, gerindo estoque, vendas de funcionários, funcionários e etc</p>
                </div>
                <div className="button_place">
                  <a target="_blank"><button disabled>link</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 5){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image5} />
            </div>
            <div className="side2">
              <h1>Science Site</h1>
              <div className="info">
                <div className="text">
                <h1>Categoria: </h1>
                  <p> Construção de Site</p>
                </div>
                <div className="text">
                <h1>Intuito: </h1>
                  <p className="get_smaller"> Um site feito para ensinar sobre alguns fatos sobre o oceano, o espaço e a evolução</p>
                </div>
                <div className="button_place">
                  <a target="_blank" href="https://malvesbruno.github.io/Science-site/"><button href="https://malvesbruno.github.io/Science-site/">link</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 6){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image6} />
            </div>
            <div className="side2">
              <h1>Eco Energy Bike</h1>
              <div className="info">
                <div className="text">
                <h1>Categoria: </h1>
                  <p> Construção de Site</p>
                </div>
                <div className="text">
                <h1>Intuito: </h1>
                  <p className="get_smaller"> Um site feito para divulgar um projeto de bicicletas que geram energia elétrica através da energia mecânica da pedalada</p>
                </div>
                <div className="button_place">
                <a target="_blank" href="https://malvesbruno.github.io/EcoEnergyBike/"><button href="https://malvesbruno.github.io/EcoEnergyBike/">link</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 7){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image7} />
            </div>
            <div className="side2">
              <h1>Foo Fighter</h1>
              <div className="info">
                <div className="text">
                <h1>Categoria: </h1>
                  <p> Desenvolvimento de Game</p>
                </div>
                <div className="text">
                <h1>Intuito: </h1>
                  <p className="get_smaller"> Um jogo baseado nos jogos do Zelda</p>
                </div>
                <div className="button_place">
                <a href={fooFighterfile} download='Foo Fighter' target="_blank"><button>Download</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    }
    }
  } else {
    if (isclicked){
      if (index === 1){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image1} />
            </div>
            <div className="side2">
              <h1>Controle de Vendas</h1>
              <div className="info">
                <div className="text">
                <h1>Category: </h1>
                  <p> App Developement</p>
                </div>
                <div className="text">
                <h1>Intention: </h1>
                  <p className="get_smaller">
                  An application created to connect sellers and control their sales.</p>
                </div>
                <div className="button_place">
                  <a href={appVendasfile} download='App-Vendas' target="_blank"><button>Download</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 2){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image2} />
            </div>
            <div className="side2">
              <h1>Flappy Bird</h1>
              <div className="info">
                <div className="text">
                <h1>Category: </h1>
                  <p>Game Developement</p>
                </div>
                <div className="text">
                <h1>Intention: </h1>
                  <p className="get_smaller"> A game based on the game Flappy bird</p>
                </div>
                <div className="button_place">
                  <a href={flappyBirdfile} download='FlappyBird' target="_blank"><button>Download</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 3){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image3} />
            </div>
            <div className="side2">
              <h1>Pull-it Train</h1>
              <div className="info">
                <div className="text">
                <h1>Category: </h1>
                  <p> Software Developement</p>
                </div>
                <div className="text">
                <h1>Intention: </h1>
                  <p className="get_smaller"> A program designed to help people who practice physical activities maintain their routine of training, supplements, medication and work</p>
                </div>
                <div className="button_place">
                  <a href={pull_itTrainfile} download='Pull-it Train' target="_blank"><button>Download</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 4){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image4} />
            </div>
            <div className="side2">
              <h1>Management Web</h1>
              <div className="info">
                <div className="text">
                <h1>Category: </h1>
                  <p>Site Build</p>
                </div>
                <div className="text">
                <h1>Intention: </h1>
                  <p className="get_smaller"> A website designed to assist in the management of companies, managing inventory, employee sales, employees, etc.</p>
                </div>
                <div className="button_place">
                  <a target="_blank"><button disabled>link</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 5){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image5} />
            </div>
            <div className="side2">
              <h1>Science Site</h1>
              <div className="info">
                <div className="text">
                <h1>Category: </h1>
                  <p>Site Build</p>
                </div>
                <div className="text">
                <h1>Intention: </h1>
                  <p className="get_smaller"> A website made to teach you about some facts about the ocean, space and evolution</p>
                </div>
                <div className="button_place">
                  <a target="_blank" href="https://malvesbruno.github.io/Science-site/"><button href="https://malvesbruno.github.io/Science-site/">link</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 6){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image6} />
            </div>
            <div className="side2">
              <h1>Eco Energy Bike</h1>
              <div className="info">
                <div className="text">
                <h1>Category: </h1>
                  <p> Site Build</p>
                </div>
                <div className="text">
                <h1>Intention: </h1>
                  <p className="get_smaller"> A website created to publicize a bicycle project that generates electrical energy through the mechanical energy of pedaling</p>
                </div>
                <div className="button_place">
                <a target="_blank" href="https://malvesbruno.github.io/EcoEnergyBike/"><button href="https://malvesbruno.github.io/EcoEnergyBike/">link</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    } else if (index === 7){
      return(
        <div className='popUp'>
          <div className="close_button">
              <button onClick={() => onButtonClicked(1)}>X</button>
          </div>
          <div className="info">
            <div className="side1">
            <ImageCarousel images={image7} />
            </div>
            <div className="side2">
              <h1>Foo Fighter</h1>
              <div className="info">
                <div className="text">
                <h1>Category: </h1>
                  <p>Game Developement</p>
                </div>
                <div className="text">
                <h1>Intention: </h1>
                  <p className="get_smaller"> A game based on the Zelda games</p>
                </div>
                <div className="button_place">
                <a href={fooFighterfile} download='Foo Fighter' target="_blank"><button>Download</button></a>
                </div>
              </div>
            </div>
          </div>
        </div>

      )
    }
    }
  }
  }

export default Portfolio_details;